import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TodoInitialDataService {

  private todoData: any;

  setTodoData(data: any): void {
    this.todoData = data;
  }

  getTodoData(): any {
    return this.todoData;
  }
}
